import {
  getForm,
  listFormSummaries,
  sendCommandBatch,
  type FormSummary,
} from '../api/formsApi';
import { plainText } from '../contracts';

export type FormsSidebarRenameResult =
  | { status: 'updated'; form: FormSummary }
  | { status: 'conflict'; form: FormSummary | null }
  | { status: 'conflict_refresh_failed' }
  | { status: 'error' };

export async function listFormsForSidebar(): Promise<FormSummary[]> {
  return listFormSummaries();
}

async function currentSummary(formId: string): Promise<FormSummary | null> {
  const forms = await listFormSummaries();
  return forms.find((form) => form.form_id === formId) ?? null;
}

export async function refreshFormForSidebarRename(form: FormSummary): Promise<FormSummary | null> {
  return currentSummary(form.form_id);
}

export async function renameFormFromSidebar(
  form: FormSummary,
  nextTitle: string,
  operationIdFactory: () => string = () => crypto.randomUUID(),
): Promise<FormsSidebarRenameResult> {
  try {
    const definition = await getForm(form.form_id);
    if (definition.draft_version !== form.draft_version) {
      return { status: 'conflict', form: await currentSummary(form.form_id) };
    }

    const result = await sendCommandBatch(definition, operationIdFactory(), [
      { type: 'update_form_title', title: plainText(nextTitle) },
    ]);
    if (!result.accepted) {
      if (result.rejection?.code === 'version_conflict') {
        return { status: 'conflict', form: await currentSummary(form.form_id) };
      }
      return { status: 'error' };
    }

    const updated = await currentSummary(form.form_id);
    return updated ? { status: 'updated', form: updated } : { status: 'error' };
  } catch {
    return { status: 'error' };
  }
}
